module.exports = __webpack_public_path__ + "static/media/comviva.fd6be5b4.png";